<template>
    <el-dialog title="请选择" :show-close="false" :visible.sync="dialogVisible" center :close-on-click-modal="false" :close-on-press-escape="false" width="850px">
        <!-- <span>这是一段信息</span> -->
        <div class="content">
            <div>
                <el-input placeholder="输入搜索" @input="basicSearch" prefix-icon="el-icon-search" v-model="keyword"></el-input>
            </div>
            <div class="comme_radio_list">
                <div v-for="(item, index) in checkInfo.options" v-show="item.isHide !== true" @click="changeCheckActive(item.optionId)" :key="index">
                    <div :class="item.isActive ? 'radio_list_item__active' : 'radio_list_item'" v-if="item.optionId">
                        <el-tooltip class="item" effect="light" :content="item.optionExplain" placement="top-start">
                            <span v-if="item.optionExplain && item.optionExplain != ''">{{ item.optionName }}</span>
                        </el-tooltip>
                        <span v-if="item.optionExplain == '' || !item.optionExplain">{{ item.optionName }}</span>
                    </div>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="canel">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    data() {
        return {
            dialogVisible: true,
            keyword: '',
            checkList: [],
            valueList: [],
            searchList: [],
            index: undefined,
            checkInfo: {}
        };
    },
    methods: {
        basicSearch() {
            if(this.keyword){
                this.checkInfo.options.map(item => {
                    if(item.optionName.includes(this.keyword)){
                        item.isHide = false
                    }else{
                        item.isHide = true
                    }
                })
            }else{
                this.checkInfo.options.map(item => {
                    item.isHide = false
                })
            }
        },
        init(info, index) {
            this.keyword = ''
            this.checkInfo = JSON.parse(JSON.stringify(info));
            this.checkInfo.options.map((item) => {
                item.isHide = false
                //如果是选中状态就放入list中
                if (item.isActive) {
                    this.checkList.push(item.optionId);
                    this.valueList.push(item.optionName);
                }
            });
            this.index = index;
            this.dialogVisible = true;
        },
        canel() {
            this.dialogVisible = false;
            this.$emit('close');
        },
        submit() {
            let obj = {
                index: this.index,
                fieIdValue: this.valueList.join(','),
                optionId: this.checkList,
                fieIdId: this.checkInfo.fieIdId,
                options: this.checkInfo.options,
                valueId: this.checkList.join(',')
            };
            this.dialogVisible = false;
            this.$emit('update', obj);
        },
        // 切换选择框状态
        changeCheckActive(id) {
            this.checkList = [];
            //存储字段值列表
            this.valueList = [];
            this.checkInfo.options.map((item) => {
                if (item.optionId == id) {
                    item.isActive = !item.isActive;
                }
                item.isHide = false
                //如果是选中状态就放入list中
                if (item.isActive) {
                    this.checkList.push(item.optionId);
                    this.valueList.push(item.optionName);
                }
            });
            this.$set(this,'checkInfo',this.checkInfo)
            this.basicSearch()
            this.$forceUpdate();
        }
    }
};
</script>
<style lang="scss" scoped>
.comme_radio_list {
    display: flex;
    flex-flow: row wrap;
    margin-top: 20px;
}

.radio_list_item {
    cursor: pointer;
    min-width: 134px;
    min-height: 35px;
    border-radius: 7px;
    border: 1px solid #c4c4c4;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #666666;
    margin-right: 25px;
    margin-bottom: 15px;
}

.radio_list_item__active {
    cursor: pointer;
    min-width: 134px;
    min-height: 35px;
    background: #4d6fff;
    border-radius: 7px;
    border: 1px solid #4d6fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #ffffff;
    margin-right: 25px;
    margin-bottom: 15px;
}
</style>
